import { DateFormat, formatCurrency, formatDate } from "../../../../../utils";
import { SavingsTransactions } from "../../../types";
import { GrossTax, ProgressRow } from "./types";

const MINUS = "−";

export const rowDateText = (date: string) =>
  formatDate(date, DateFormat.DMY_SPACE);

// A row that never moved the balance shows no plus sign, so it can't read as money that came in.
export const rowAmountText = ({ amount, isNeutral }: ProgressRow): string => {
  const magnitude = formatCurrency(Math.abs(amount));
  if (amount < 0) {
    return `${MINUS}${magnitude}`;
  }
  return isNeutral ? magnitude : `+${magnitude}`;
};

export const earnedChipText = (cashbackEarned: number) =>
  `+${formatCurrency(cashbackEarned)} cashback`;

export const rowTitleOf = ({ type, secondary }: ProgressRow) =>
  secondary ? `${type} · ${secondary}` : type;

export const grossTaxOf = ({
  grossAmount,
  taxWithheld,
}: SavingsTransactions): GrossTax | null => {
  if (grossAmount === null || !taxWithheld) {
    return null;
  }
  return {
    gross: formatCurrency(grossAmount),
    tax: formatCurrency(taxWithheld),
  };
};
